import { ResetPasswordResponse } from "@syla/shared/types/responses/ResetPasswordResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function resetPassword(
  token: string | null,
  password: string,
): Promise<ResetPasswordResponse> {
  try {
    const response = await axios.post<ResetPasswordResponse>(
      "/users/reset-password",
      {
        token,
        password,
      },
    );
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
